import {
    RESELLER_GOOGLE_MAP_RECEIVE,
    RESELLER_GOOGLE_MAP_RECEIVE_FOR_PRODUCT, RESELLER_GOOGLE_MAP_SET_STATUS
} from "../Actions/ResellerGoogleMapProduct.action";

const defaultState = {
    status: 'loading',
    productOnlineResellers: [],
    productResellers: [],
    resellerCountries: [],
    resellerData: [],
}
export const resellerProduct = (state = defaultState, action) => {
    switch (action.type) {
    case RESELLER_GOOGLE_MAP_SET_STATUS:
        return { 
            ...state,
            ...action.payload
        };
    case RESELLER_GOOGLE_MAP_RECEIVE_FOR_PRODUCT:
        return {
            ...state,
            status: action.payload.status,
            productOnlineResellers: action.payload.productOnlineResellers,
            productResellers: action.payload.productResellers,
            resellerCountries: action.payload.resellerCountries,
        };
    case RESELLER_GOOGLE_MAP_RECEIVE:
        return {
            ...state,
            resellerData: action.payload.reSellers.results,
            countries: action.payload.reSellers.countries,
        };
    default:
        return state;
    }
}
